/**
* DevExpress Analytics (core\binding\_jsDesignerBindingCommon.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var utils_1 = require("../../serializer/utils");
var _requestHelper_1 = require("./_requestHelper");
var _processError_1 = require("../internal/_processError");
var _internal_1 = require("../../serializer/_internal");
var templateUtils_1 = require("../../property-grid/widgets/templateUtils");
var JSDesignerBindingCommon = (function (_super) {
    __extends(JSDesignerBindingCommon, _super);
    function JSDesignerBindingCommon(_options, _customEventRaiser) {
        var _this = _super.call(this) || this;
        _this._options = _options;
        _this._customEventRaiser = _customEventRaiser;
        _this._templateHtml = templateUtils_1.getTemplate('dxrd-designer');
        return _this;
    }
    JSDesignerBindingCommon.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        if (this.sender && this.sender instanceof utils_1.Disposable)
            this.sender.dispose();
        this.removeProperties();
    };
    JSDesignerBindingCommon.prototype._fireEvent = function (eventName, args) {
        if (this._customEventRaiser) {
            this._customEventRaiser(eventName, args);
            return;
        }
        this._options && this._options.callbacks && this._options.callbacks[eventName] && this._options.callbacks[eventName](this.sender, args);
    };
    JSDesignerBindingCommon.prototype._getServerActionUrl = function (host, uri) {
        return _requestHelper_1.RequestHelper.generateUri(host, uri);
    };
    JSDesignerBindingCommon.prototype._getAvailableEvents = function (events, prefix) {
        var _this = this;
        var result = events;
        if (prefix && this._options.callbacks[prefix]) {
            Object.keys(events).forEach(function (propertyName) {
                result[propertyName] = _this._options.callbacks[prefix][propertyName] || events[propertyName];
            });
        }
        else {
            Object.keys(events).forEach(function (propertyName) {
                result[propertyName] = _this._options.callbacks[propertyName] || events[propertyName];
            });
        }
        return result;
    };
    JSDesignerBindingCommon.prototype._getLocalizationRequest = function () {
        var deferred = $.Deferred();
        var requestOptions = this._options.requestOptions;
        if (requestOptions.getLocalizationAction) {
            var actionUrl = this._getServerActionUrl(requestOptions.host, requestOptions.getLocalizationAction);
            $.getJSON(actionUrl)
                .fail(function (jqXHR, textStatus, errorThrown) {
                try {
                    _processError_1._processError(errorThrown.message, $.Deferred(), jqXHR, textStatus);
                }
                finally {
                    deferred.reject();
                }
            }).done(function (localization) {
                deferred.resolve(localization);
            });
        }
        else {
            deferred.resolve();
        }
        return deferred.promise();
    };
    JSDesignerBindingCommon.prototype._createDisposeFunction = function (element) {
        var _this = this;
        _internal_1.addDisposeCallback(element, function () {
            _this.dispose();
        });
    };
    return JSDesignerBindingCommon;
}(utils_1.Disposable));
exports.JSDesignerBindingCommon = JSDesignerBindingCommon;
